import { useEffect, useState } from 'react';
import {
  endDateisAfterBeforeDate,
  notAfterToday,
} from 'utils/dates-validators';

export const useInformFilterDatesError = (
  selectedFechaDesde,
  selectedFechaHasta
) => {
  const [errorFechaHasta, setErrorFechaHasta] = useState('');

  useEffect(() => {
    if (selectedFechaDesde && selectedFechaHasta) {
      setErrorFechaHasta(
        notAfterToday(selectedFechaHasta) ||
          endDateisAfterBeforeDate(selectedFechaDesde, selectedFechaHasta)
      );
    } else if (selectedFechaDesde || selectedFechaHasta) {
      setErrorFechaHasta('Debes rellenar la otra fecha');
    } else {
      setErrorFechaHasta('');
    }
  }, [selectedFechaDesde, selectedFechaHasta]);

  return errorFechaHasta;
};

export const useInformMesesError = (selectedMeses) => {
  const [errorMeses, setErrorMeses] = useState('');

  useEffect(() => {
    if (selectedMeses && selectedMeses !== '') {
      setErrorMeses('');
    } else {
      setErrorMeses('Debe seleccionarse un mes');
    }
  }, [selectedMeses]);

  return errorMeses;
};
